import React from 'react';
import {Atom} from '@packages/systems/wfdl';
import {sanitizeProp} from '@packages/utilities/react-sanitize';

const Iframe = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    const sanitizedAttributes = attributes.withMutations((mut_attributes) => {
      mut_attributes.forEach((value, key) => {
        if (typeof key === 'string' && typeof value === 'string') {
          const sanitized = sanitizeProp(key, value);
          if (sanitized !== value) {
            mut_attributes.set(key, sanitized);
          }
        }
      });
    });
    return (
      // This component only supports childless iframes, so `renderChildren` is not called
      // TODO: fix jsx-a11y lint error
      // eslint-disable-next-line jsx-a11y/iframe-has-title
      <iframe {...generateAttributes(sanitizedAttributes, classes)} />
    );
  }
);

const config = Atom.create({
  displayName: 'Iframe',
  showEmpty: false,
  render: Iframe,
});

export default config;
